import type { PrescriptionService } from '@truepill/openapi-sdk'

export interface ExternalLocation {
  id: string
  npi: string
  name?: string
  address: {
    street1: string
    street2?: string
    city: string
    state: string
    zip: string
    phone?: string
    fax?: string
  }
}

export interface ExternalTransfer {
  id: string
  externalLocation: ExternalLocation
  status: PrescriptionService.ExternalTransferStatusV1
  createdAt: string
  updatedAt: string
  locked: boolean
  lockedAt?: string
  lockedBy?: string
  prescription: {
    corePrescriptionId: number
    corePrescriptionToken: string
    medicationName: string
    rxNumber: string
    verified?: boolean
  }
  patient?: {
    firstName: string
    lastName: string
  }
  customer?: {
    id: string
    name: string
    legacyId: number
  }
  lastCallAttemptOutcome?: string
  lastCallAttemptAt?: string
  callAttemptCount?: number
  callAttempts?: CallAttempts[]
  receivingPharmacistName?: string
}

export interface CallAttempts {
  createdAt: string
  outcome: PrescriptionService.CallAttemptOutcome
}

export enum ExternalTransferStatusDisplay {
  PENDING = 'Ready To Transfer',
  FAILED = 'Transfer Rejected',
  AUTOMATION_FAILED = 'Automated Fax Failed',
  TRANSFERRED = 'TRANSFERRED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  AUTOMATION_PENDING = 'Automated Fax Pending',
  NEEDS_VERIFICATION = 'Prescription Verification',
  READY_TO_TRANSFER = 'Ready To Transfer',
}

export enum AttemptStatuses {
  MaxHold = 'MAX_HOLD',
  PharmacyClosed = 'PHARMACY_CLOSED',
  WrongNumber = 'WRONG_NUMBER',
  NoAnswer = 'NO_ANSWER',
  CallbackRequested = 'CALLBACK_REQUESTED',
}

export enum AttemptStatusesDisplay {
  MAX_HOLD = 'Max hold',
  PHARMACY_CLOSED = 'Pharmacy closed',
  WRONG_NUMBER = 'Wrong / invalid number',
  NO_ANSWER = 'No answer',
  CALLBACK_REQUESTED = 'Call back requested',
}
